import { exportExcel } from "@api/stores/purchaseInvoiceReport/exportExcel/path";
import { exportPDF } from "@api/stores/purchaseInvoiceReport/exportPDF/path";
import { exportSinglePDF } from "@api/stores/purchaseInvoiceReport/exportSinglePDF/path";
import { stats } from "@api/stores/purchaseInvoiceReport/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/purchase-invoice-reports/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const purchaseInvoiceReport = {
  getAll: apiPathFunc(pathBase),
  stats,
  exportPDF,
  exportExcel,
  exportSinglePDF,
};
